import { createContext, type PropsWithChildren } from "react";
import { type PropsWithTestID } from "@boi/components-core";

import { type MenuV2Props } from "./MenuV2";

type MenuV2ContextValue = PropsWithTestID & Pick<MenuV2Props, "popoverProps">;

const MenuV2Context = createContext<MenuV2ContextValue>(
  {} as MenuV2ContextValue
);

export type MenuV2ProviderProps = MenuV2ContextValue & PropsWithChildren;

export const MenuV2Provider = (props: MenuV2ProviderProps) => {
  const { children, ...providerValue } = props;

  return (
    <MenuV2Context.Provider value={providerValue}>
      {children}
    </MenuV2Context.Provider>
  );
};

export default MenuV2Context;
